import type { OperatorData } from './MetricRepository';

export default {
  toPacket: ({ offset, offsetMetrics }: OperatorData<'heartRate'>) =>
    offsetMetrics.filter((_: number, i: number) => i <= offset).pop(),

  toValue: ({ offsetMetrics }: OperatorData<'heartRate'>) =>
    offsetMetrics.reduce((acc: number, v: number) => acc + v, 0),
};
